import { z } from "zod";
/**
 * Money in JSON: an integer number of paisa (CLAUDE.md §7, docs/specs/contracts-api-client.md). Zod's `int()`
 * accepts only safe integers (|n| ≤ 2⁵³ − 1 paisa); the API converts to and from `bigint` at the edge. Negative
 * amounts are allowed (refunds, reversals); a schema that must be positive adds `.positive()`.
 */
export const paisa = () => z.int();
//# sourceMappingURL=money.js.map